import { EGYEmploymentVisa } from "./visa-steps/EGY/egy-employement-visa";

export enum VisaTypesValues {
  VisaPreApproval = 'VisaPreApproval',
  BusinessVisa = 'BusinessVisa',
  IqamaRenewal = 'IqamaRenewal',
  PassportInfoUpdate = 'PassportInfoUpdate',
  IqamaIssuance = 'IqamaIssuance',
  GOSIadditional = 'GOSIadditional',
  GOSIremoval = 'GOSIremoval',
  VisaCancellation = 'VisaCancellation',
  ExitIqamatransfer = 'ExitIqamatransfer',
  Exitpermission = 'Exitpermission',
  EmploymentVisa = 'EmploymentVisa',
  IqamaTransfer = 'IqamaTransfer',
  DocumentSupport ='DocumentSupport',
  AREBusinessVisitVisa = 'ARE-BusinessVisitVisa',
  ARETawteen = 'ARE-Tawteen',
  AREBusinessVisitVisaRenewal = 'ARE-BusinessVisitVisaRenewal',
  AREBusinessVisitVisaCancellation = 'ARE-BusinessVisitVisaCancellation',
  AREMissionVisa = 'ARE-MissionVisa',
  AREMissionVisaRenewal = 'ARE-MissionVisaRenewal',
  ARERelativeWorkPermit = 'ARE-RelativeWorkPermit',
  ARERelativeWorkPermitRenewal = 'ARE-RelativeWorkPermitRenewal',
  ARETemporaryPTWorkPermit = 'ARE-TemporaryPTWorkPermit',
  AREUaeGccNationalWorkPermit = 'ARE-UaeGccNationalWorkPermit',
  AREGccUaeNationalWorkPermitRenewal = 'ARE-GccUaeNationalWorkPermitRenewal',
  AREDepVisaGccMarriedToExpat = 'ARE-DepVisaGccMarriedToExpat',
  AREEmploymentVisaIssuance = 'ARE-EmploymentVisaIssuance',
  ARECicpaCard = 'ARE-CicpaCard',
  AREChangeOfNationality = 'ARE-ChangeOfNationality',
  ARETransferResidency = 'ARE-TransferResidency',
  AREChangeOfProfession = 'ARE-ChangeOfProfession',
  AREEmploymentVisaRenewal = 'ARE-EmploymentVisaRenewal',
  AREDependentsVisaIssuance = 'ARE-DependentsVisaIssuance',
  AREDependentsVisaCancellation = 'ARE-DependentsVisaCancellation',
  AREDependentsVisaRenewal = 'ARE-DependentsVisaRenewal',
  AREPensionAddition = 'ARE-PensionAddition',
  AREPensionRemoval = 'ARE-PensionRemoval',
  ARELabourCardCancellation = 'ARE-LabourCardCancellation',
  AREVisaCancellationInside = 'ARE-VisaCancellationInside',
  AREVisaCancellationOutside = 'ARE-VisaCancellationOutside',
  AREGoldenVisa = 'ARE-GoldenVisa',
  AREGoldenVisaRenewal = 'ARE-GoldenVisaRenewal',
  AREMissionVisaCancellation = 'ARE-MissionVisaCancellation',
  ARELabourcardWorkPermitIssuance = 'ARE-LabourcardWorkPermitIssuance',

  OMNWorkPermitPreAprroval = 'OMN-WorkPermitPreAprroval',
  OMNEmploymentVisa = 'OMN-EmploymentVisa',
  OMNResidencyPermitTransfer = 'OMN-ResidencyPermitTransfer',
  OMNMOLContractIssuance = 'OMN-MOLContractIssuance',
  OMNResidencyPermitIssuance = 'OMN-ResidencyPermitIssuance',
  OMNResidencyPermitRenewal = 'OMN-ResidencyPermitRenewal',
  OMNResidencyPermitCancellation = 'OMN-ResidencyPermitCancellation',
  OMNExitResidencyPermitTransfer = 'OMN-ExitResidencyPermitTransfer',
  OMNMOLContractCancellation = 'OMN-MOLContractCancellation',
  OMNShortTermVisa = 'OMN-ShortTermVisa',
  OMNShortTermVisaExtension = 'OMN-ShortTermVisaExtension',
  OMNDependentsVisa = 'OMN-DependentsVisa',
  OMNTransferOfResidencyPermitToNewPassport = 'OMN-TransferOfResidencyPermitToNewPassport',
  OMNLetterRequest = 'OMN-LetterRequest',
  OMNDocumentAttestation = 'OMN-DocumentAttestation',
  OMNOther = 'OMN-Other',
  OMNChangeOfProfession = 'OMN-ChangeOfProfession',
  OMNDependentsRPIssuance='OMN-DependentsRP-Issuance',
  OMNDependentsRPRenewal = 'OMN-DependentsRP-Renewal',
  OMNDependentsVisaRenewal = 'OMN-DependentsVisaRenewal',
  

  BHREmploymentVisa = 'BHR-EmploymentVisa',
  BHRVisaTransfer = 'BHR-VisaTransfer',
  BHRGOSIRegistration = 'BHR-GOSIRegistration',
  BHRResidencyPermitAndCPRIssuance = 'BHR-ResidencyPermitAndCPRIssuance',
  BHRResidencyPermitRenewal = 'BHR-ResidencyPermitRenewal',
  BHRGOSITermination = 'BHR-GOSITermination',
  BHRShortTermVisa = 'BHR-ShortTermVisa',
  BHRShortTermVisaExtension = 'BHR-ShortTermVisaExtension',
  BHRDependentsResidencyIssuance = 'BHR-DependentsResidencyIssuance',
  BHRResidencyPermitCancellation = 'BHR-ResidencyPermitCancellation',
  BHRExitEmploymentVisaTransfer = 'BHR-ExitEmploymentVisaTransfer',
  BHRKSABusinessVisaSupport = 'BHR-KSABusinessVisaSupport',
  BHRTransferOfResidencyPermitToNewPassport = 'BHR-TransferOfResidencyPermitToNewPassport',
  BHRChangeOfProfession = 'BHR-ChangeOfProfession',
  BHRCPRSupport = 'BHR-CPRSupport',
  BHRLetterRequest = 'BHR-LetterRequest',
  BHROther = 'BHR-Other',

  QATVisaPreAprroval = 'QAT-VisaPreAprroval',
  QATEmploymentVisa = 'QAT-EmploymentVisa',
  QATResidencyPermitTransfer = 'QAT-ResidencyPermitTransfer',
  QATResidencyPermitIssuance = 'QAT-ResidencyPermitIssuance',
  QATWorkPermitIssuance = 'QAT-WorkPermitIssuance',
  QATWorkPermitRenewal = 'QAT-WorkPermitRenewal',
  QATResidencyPermitRenewal = 'QAT-ResidencyPermitRenewal',
  QATResidencyPermitCancellation = 'QAT-ResidencyPermitCancellation',
  QATExitResidencyPermitTransfer = 'QAT-ExitResidencyPermitTransfer',
  QATWorkPermitCancellation = 'QAT-WorkPermitCancellation',
  QATBusinessVisa = 'QAT-BusinessVisa',
  QATBusinessVisaExtension = 'QAT-BusinessVisaExtension',
  QATExitPermission = 'QAT-ExitPermission',
  QATChangeOfProfession = 'QAT-ChangeOfProfession',
  QATTransferOfResidencyPermitToNewPassport = 'QAT-TransferOfResidencyPermitToNewPassport',
  QATGovernmentGatePass = 'QAT-GovernmentGatePass',
  QATLetterRequest = 'QAT-LetterRequest',
  QATDocumentAttestation = 'QAT-DocumentAttestation',

  KWTVisaPreApproval = 'KWT-VisaPreApproval',
  KWTEmploymentVisa = 'KWT-EmploymentVisa',
  KWTResidencyTransfer = 'KWT-ResidencyTransfer',
  KWTResidencePermitIssuance = 'KWT-ResidencePermitIssuance',
  KWTWorkPermitIssuance = 'KWT-WorkPermitIssuance',
  KWTCommercialVisitVisa = 'KWT-CommercialVisitVisa',
  KWTResidencyRenewal = 'KWT-ResidencyRenewal',
  KWTWorkPermitRenewal = 'KWT-WorkPermitRenewal',
  KWTWorkPermitCancellation = 'KWT-WorkPermitCancellation',
  KWTResidencyPermitCancellation = 'KWT-ResidencyPermitCancellation',
  KWTExitResidencyPermitTransfer = 'KWT-ExitResidencyPermitTransfer',
  KWTTransferOfResidencyToNewPassport = 'KWT-TransferOfResidencyToNewPassport',
  KWTKSABusinessVIsaSupport = 'KWT-KSABusinessVIsaSupport',
  KWTCivilIDSupport = 'KWT-CivilIDSupport',
  KWTChangeOfProfession = 'KWT-ChangeOfProfession',
  KWTDataModification = 'KWT-DataModification',
  KWTDependentsResidencyVisaSupport = 'KWT-DependentsResidencyVisaSupport',
  KWTLetterRequest = 'KWT-LetterRequest',
  KWTDocumentAttestation = 'KWT-DocumentAttestation',
  KWTCommercialVisitVisaExtension = 'KWT-CommercialVisitVisaExtension',
  KWTOther = 'KWT-Other',

  EGYEmploymentVisa = 'EGY-EmploymentVisa',
  EGYKSABusinessVisaSupport = 'EGY-KSABusinessVisaSupport',
  EGYSIRegistration = 'EGY-SIRegistration',
  EGYSIPrint = 'EGY-SIPrint',
  EGYSICancellation = 'EGY-SICancellation',
  EGYEmploymentVisaRenewal = 'EGY-EmploymentVisaRenewal',
  EGYEmploymentVisaCancellation = 'EGY-EmploymentVisaCancellation',
  EGYDependentRPIssuance = 'EGY-DependentRPIssuance',
  EGYDependentRPRenewal = 'EGY-DependentRPRenewal',
  EGYDependentRPCancellation = 'EGY-DependentRPCancellation',
  EGYNJDocumentValidation = 'EGY-NJDocumentValidation',
  EGYNationalIDFormStamping = 'EGY-NationalIDFormStamping',

  
  PAKBusinessVisa = 'PAK-BusinessVisa',

  JORKSABusinessVisaSupport = 'JOR-KSABusinessVisaSupport',
  JORBusinessVisitVisa = 'JOR-BusinessVisitVisa',
  JORBusinessVisitVisaExtension = 'JOR-BusinessVisitVisaExtension',

  BTVisaApplicationSupport = 'BT-VisaApplicationSupport',
  BTVisaConsultation = 'BT-VisaConsultation',
  BTVisaValidation='BT-VisaValidation'
}
